import { useState, useRef, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from 'react-aria-components';



const Collapsible = () => {
	const { t } = useTranslation('forms');

	const [ isOpen, setIsOpen ] = useState(false);
	const contentRef = useRef<HTMLDivElement>(null);

	
	useEffect(() => {
		if (isOpen && contentRef && contentRef.current) {
			setTimeout(() => contentRef?.current?.scrollIntoView({ behavior: 'smooth', block: 'nearest' }), 150);
		}
	}, [ isOpen, contentRef ]);

	
	return (
		<div className='collar-info-section'>
			
			<Button className={`collapsible-collar-info-button disable-selection${isOpen ? ' active' : ''}`} onPress={() => setIsOpen(!isOpen)}>
				<p>{t('collarType.infoText') + ' '}<span>+</span></p>
			</Button>
			
			<div
				className='collapsible-collar-info-content'
				style={{ maxHeight: isOpen && contentRef && contentRef.current ? `${contentRef.current.scrollHeight}px` : '0'}}
				ref={contentRef}>
				
				<div className='collar-info-elements'>
					<p>{t('collarType.withBuckleInfo')}</p>
					<p>
						{t('collarType.withoutBuckleInfo1') + ' '}
						<span>{t('collarType.withoutBuckleInfo2')}</span>
					</p>
				</div>
			</div>
		
		</div>
	);
}

export default Collapsible;